module.exports = __webpack_public_path__ + "img/pinxiangBottom_top.fb8240ed.png";